import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'app-ds-card-media',
  templateUrl: './ds-card-media.component.html',
  styleUrls: ['./ds-card-media.component.scss']
})
export class DsCardMediaComponent {
  @Input() ratio: string = '16 / 10';

  @HostBinding('class.ds-card__media') readonly hostClass = true;

  @HostBinding('style.aspectRatio')
  get aspectRatio(): string {
    return this.ratio;
  }
}
